/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { BcToken } from "./BcToken";

export class BcTokenFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<BcToken> {
    return super.deploy(overrides || {}) as Promise<BcToken>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BcToken {
    return super.attach(address) as BcToken;
  }
  connect(signer: Signer): BcTokenFactory {
    return super.connect(signer) as BcTokenFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BcToken {
    return new Contract(address, _abi, signerOrProvider) as BcToken;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "_claim_id",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_by",
        type: "address",
      },
    ],
    name: "ApproveMintEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "_claim_id",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "_request_id",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "_multi_sig_size",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "_minting_fee",
        type: "uint16",
      },
    ],
    name: "MintRequestEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "_claim_id",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "_request_id",
        type: "uint64",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_claim_amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_opn_amount",
        type: "uint256",
      },
    ],
    name: "ReduceMintFeeEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "APPROVAL_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BURNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINT_REQUEST_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "request_id",
        type: "uint64",
      },
    ],
    name: "approve_mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "claim_id",
        type: "string",
      },
    ],
    name: "approve_mint_by_claim_id",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "claim_ids",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "get_fee_collector",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "get_id_by_claim_id",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "get_is_locked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "id",
        type: "uint64",
      },
    ],
    name: "get_mint",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "claim_id",
        type: "string",
      },
    ],
    name: "get_mint_by_claim_id",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "get_mint_id",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "get_minting_fee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "get_multi_sig_size",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "get_openx_collector",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "get_opn_address",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_opnAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "claim_id",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount_opn_to_reduce_fee",
        type: "uint256",
      },
    ],
    name: "mint_request",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    name: "mint_requests",
    outputs: [
      {
        internalType: "string",
        name: "claim_id",
        type: "string",
      },
      {
        internalType: "uint16",
        name: "minting_fee",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minted_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount_opn_to_reduce_fee",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "multi_sig_size",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "claim_id",
        type: "string",
      },
    ],
    name: "reduce_fee_by_claim_id",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "id",
        type: "uint64",
      },
    ],
    name: "reduce_fee_by_id",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_fee_collector",
        type: "address",
      },
    ],
    name: "update_fee_collector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_is_locked",
        type: "bool",
      },
    ],
    name: "update_is_locked",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "_minting_fee",
        type: "uint16",
      },
    ],
    name: "update_minting_fee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_multi_sig_size",
        type: "uint8",
      },
    ],
    name: "update_multi_sig_size",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_openx_collector",
        type: "address",
      },
    ],
    name: "update_openx_collector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "opn_new",
        type: "address",
      },
    ],
    name: "update_opn_address",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
